import { Box, Skeleton } from '@mui/material';
import { FRAGMENT_CARD_PADDING_X } from '../../fragment-card/constants';

/**
 * One skeleton placeholder card matching FragmentCard layout for video fragments.
 */
export function VideoFragmentCardSkeleton() {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 1,
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Skeleton variant="rectangular" sx={{ width: '100%', height: 'auto', aspectRatio: '16/9' }} />
      <Box sx={{ p: 1.5 }}>
        <Skeleton width="80%" height={24} />
      </Box>
      <Box sx={{ px: FRAGMENT_CARD_PADDING_X, pb: 1.5, display: 'flex', gap: 1 }}>
        <Skeleton width={80} height={20} />
        <Skeleton width={60} height={20} />
      </Box>
    </Box>
  );
}
